import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Chicago.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Enhancing Digital Presence of Businesses with Software Development
              in Chicago
            </h2>
            <p>
              As a thriving software development company in Chicago, TekRevol
              offers an extensive array of capabilities. Our expertise
              encompasses both native and cross-platform app development, driven
              by our commitment to incorporating cutting-edge advancements
              through careful integration and distinctive feature customization.{" "}
            </p>
            <p>
              Our strong presence in Chicago empowers us to guide businesses
              toward success through digital enablement and proactive
              consultation. Our adept software developers in Chicago offer
              comprehensive solutions, spanning software user interface design,
              MVP development, prototyping, frontend and backend development,
              quality assurance, testing, deployment, and strategic software
              marketing.
            </p>
            <p>
              As a prominent software development company in Chicago, we
              wholeheartedly believe in the transformative potential of digital
              solutions to distinguish businesses and enhance their competitive
              advantage.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
